/** Customers of the connected user's effective perimeter, for every customer picker. */
export const PERIMETER_CUSTOMERS_ENDPOINT = '/api/users/me/customers/';

/** Enough to spot a single-customer perimeter and to offer a first choice without a search. */
export const PERIMETER_CUSTOMERS_PREVIEW_LIMIT = 20;

export type PerimeterCustomer = { id: number; oss_code: string };
